/**
 * ModeToggle — segmented Sliders | Blocks switch (compact, for header bar)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import type { FormulaGroupMode } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

export interface ModeToggleProps {
  mode: FormulaGroupMode;
  onChange: (next: FormulaGroupMode) => void;
}

const OPTIONS: ReadonlyArray<{ value: FormulaGroupMode; label: string }> = [
  { value: 'sliders', label: 'Sliders' },
  { value: 'blocks', label: 'Blocks' },
];

const ModeToggle: FC<ModeToggleProps> = ({ mode, onChange }) => (
  <div
    role="tablist"
    aria-label="Formula mode"
    className="inline-flex h-7 items-center gap-px rounded border border-input bg-muted/40 p-px"
  >
    {OPTIONS.map((opt) => {
      const active = mode === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(opt.value)}
          className={cn(
            'inline-flex h-5 items-center rounded-sm px-1.5 text-[10.5px] font-semibold transition-colors',
            active
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default ModeToggle;
